import React from 'react';
import withIcon from '../utilities/withIcon';

const IconComment = () => {
  return (
    <g>
      <path d="m10.3594.6035h-4.7188a5.6035 5.6035 0 0 0 0 11.207h1.6094v2.8359a.7512.7512 0 0 0 .4385.6826.7588.7588 0 0 0 .3115.0675.7494.7494 0 0 0 .4922-.1836l5.7978-5.0381c.0137-.0117.0264-.0244.0391-.0371a5.5412 5.5412 0 0 0 1.6338-3.9307 5.61 5.61 0 0 0 -5.6035-5.6035zm2.9248 8.457-4.5342 3.9405v-1.94a.75.75 0 0 0 -.75-.75h-2.3594a4.1035 4.1035 0 0 1 0-8.207h4.7187a4.1082 4.1082 0 0 1 4.1036 4.103 4.0463 4.0463 0 0 1 -1.1787 2.8535z" />
    </g>
  );
};

export default withIcon(IconComment);
